<template>
    <div class="word_cloud_wrap">
        <table class="board_table">
            <colgroup>
                <col width="20%" />
                <col width="auto" />
                <col width="auto" />
            </colgroup>
            <thead>
                <tr>
                    <th>순번</th>
                    <th>키워드</th>
                    <th>결과 수</th>
                </tr>
            </thead>
            <tbody v-if="!props.loading && props.chartData">
                <tr v-for="(item, idx) in props.chartData.slice(0, 20)" :key="idx">
                    <td>{{ idx + 1 }}</td>
                    <td>{{ item.keyword }}</td>
                    <td>{{ item.cnt.toLocaleString() }}</td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td :colspan="10">
                        <Spinner />
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="board_graph_list wordcloud_graph">
            <template v-if="!props.loading">
                <Chart style="min-height: 400px" v-if="chartData" :defaultLayout="chartLayout" :data="chartData"></Chart>
                <NoResult v-else></NoResult>
            </template>
            <Spinner v-else></Spinner>
        </div>
    </div>
</template>

<script lang="ts" config>
    import {
        Chart,
        numberFormat,
        reactive,
        LayoutOption,
        Spinner,
        ref,
        ChartData,
        onMounted,
        watch,
        chartDateFormat2,
        setWordCloudData,
        NoResult,
    } from "@/BaseComponent";
    export default {
        props: {
            loading: Boolean,
            chartData: Array<any>,
        },
        components: {
            Chart,
            Spinner,
            NoResult,
        },
        setup(props: any) {
            const chartData = ref<ChartData | null>();
            const chartLayout = reactive({
                type: "wordCloud",
                xAxisKey: "",
            } as LayoutOption);

            onMounted(() => {
                chartData.value = null;
                if (props.chartData && props.chartData.length > 0) {
                    chartData.value = setWordCloudData(props.chartData.slice(0, 500));
                }
            });

            watch(
                () => props.chartData,
                (newData) => {
                    chartData.value = null;
                    if (newData && newData.length > 0) {
                        chartData.value = setWordCloudData(newData.slice(0, 500));
                    }
                },
            );
            return {
                props,
                chartLayout,
                numberFormat,
                chartData,
                chartDateFormat2,
            };
        },
    };
</script>

<style scoped>
    .word_cloud_wrap {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    #board_layer .board_table {
        width: 30%;
    }

    .board_graph_list {
        padding-top: 20px;
        width: 80%;
    }

    #board_layer table.board_table thead th {
        background-color: #012f5c;
        color: #ffffff;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.2;

        border: 1px solid #dfdfdf;
        height: auto;
    }

    #board_layer table.board_table tbody tr td {
        background-color: #ffffff;
        color: #012f5c;
        font-size: 16px;
        font-weight: 700;
        border: 1px solid #dfdfdf;
        height: auto;
    }
</style>
